"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTableViewSchema = exports.saveTableViewSchema = exports.JOB_SCOPED_VIEW_SCREENS = exports.tableViewStateSchema = exports.TABLE_VIEW_SCREENS = exports.recentRecordSchema = exports.RECENT_RECORDS_LIMIT = exports.RECENT_RECORD_KIND_LABELS = exports.RECENT_RECORD_KINDS = exports.savePreferenceSchema = exports.preferenceKeySchema = exports.PREFERENCE_KEYS_MAX = exports.PREFERENCE_VALUE_MAX_CHARS = exports.PREFERENCE_KEY_PATTERN = void 0;
exports.recentRecordsOf = recentRecordsOf;
exports.withVisit = withVisit;
const zod_1 = require("zod");
const schemas_1 = require("./schemas");
/**
 * S32 — a person's interface preferences, kept on the server so they follow them to any device
 * (DECISIONS-LOG S29–S32 Q26): density, column widths and visibility, recently viewed records,
 * dismissed hints. The browser keeps a copy only as a fast first read.
 */
/** `table.candidates.widths`, `palette.recent`, `ui.density` — dotted lowercase words. */
exports.PREFERENCE_KEY_PATTERN = /^[a-z][a-z0-9-]{0,40}(\.[a-z0-9][a-z0-9-]{0,40}){0,4}$/;
/** A preference is a small thing; a layout of 40 columns fits many times over. */
exports.PREFERENCE_VALUE_MAX_CHARS = 20_000;
exports.PREFERENCE_KEYS_MAX = 200;
exports.preferenceKeySchema = zod_1.z.string().regex(exports.PREFERENCE_KEY_PATTERN, 'Not a preference name.');
exports.savePreferenceSchema = zod_1.z
    .object({ value: zod_1.z.json() })
    .refine((input) => JSON.stringify(input.value).length <= exports.PREFERENCE_VALUE_MAX_CHARS, { message: 'That preference is too large.', path: ['value'] });
// --- Recently viewed (06-qol §1, Q29) --------------------------------------------------------
exports.RECENT_RECORD_KINDS = ['candidate', 'application', 'job', 'requisition', 'offer', 'interview', 'pool', 'position'];
exports.RECENT_RECORD_KIND_LABELS = {
    candidate: 'Candidate',
    application: 'Application',
    job: 'Job',
    requisition: 'Requisition',
    offer: 'Offer',
    interview: 'Interview',
    pool: 'Talent pool',
    position: 'Position',
};
exports.RECENT_RECORDS_LIMIT = 10;
exports.recentRecordSchema = zod_1.z.object({
    kind: zod_1.z.enum(exports.RECENT_RECORD_KINDS),
    id: schemas_1.uuidSchema,
    title: zod_1.z.string().min(1).max(200),
    /** "Senior accountant", "JOB-2026-0004" — what tells two Rafiqs apart. */
    subtitle: zod_1.z.string().max(200).nullable(),
    path: zod_1.z.string().regex(/^\/[^\s]*$/).max(300),
    viewedAt: zod_1.z.iso.datetime(),
});
/** Newest first, one entry per record, at most ten. Unreadable entries are dropped. */
function recentRecordsOf(value) {
    if (!Array.isArray(value))
        return [];
    return value.flatMap((entry) => {
        const parsed = exports.recentRecordSchema.safeParse(entry);
        return parsed.success ? [parsed.data] : [];
    });
}
function withVisit(current, visit) {
    return [visit, ...current.filter((entry) => entry.id !== visit.id)].slice(0, exports.RECENT_RECORDS_LIMIT);
}
// --- Saved views on record tables (06-qol §3, Q28) ---------------------------------------------
/** The record tables that keep named views; the pipeline keeps its own (S16). */
exports.TABLE_VIEW_SCREENS = ['requisitions', 'jobs', 'candidates', 'candidate-search', 'pools', 'pool', 'positions', 'users', 'question-bank', 'ranking'];
exports.tableViewStateSchema = zod_1.z.object({
    /** The address bar's own filter strings, so applying a view and opening a link are the same. */
    filters: zod_1.z.record(zod_1.z.string().max(60), zod_1.z.string().max(500)).refine((filters) => Object.keys(filters).length <= 40, 'Too many filters.'),
    hiddenColumns: zod_1.z.array(zod_1.z.string().max(60)).max(60).default([]),
});
const viewName = zod_1.z.string().trim().min(1, 'Give the view a name.').max(60, 'Names can be up to 60 characters.');
/** ADR 0049: a Ranking view belongs to one job (Part 1 Q1); every other screen's views have none. */
exports.JOB_SCOPED_VIEW_SCREENS = ['ranking'];
exports.saveTableViewSchema = zod_1.z
    .object({
    screen: zod_1.z.enum(exports.TABLE_VIEW_SCREENS),
    jobId: schemas_1.uuidSchema.nullable().default(null),
    name: viewName,
    isShared: zod_1.z.boolean().default(false),
    state: exports.tableViewStateSchema,
})
    .refine((input) => exports.JOB_SCOPED_VIEW_SCREENS.includes(input.screen) === (input.jobId !== null), { message: 'A Ranking view is saved on its job.', path: ['jobId'] });
exports.updateTableViewSchema = zod_1.z.object({
    name: viewName,
    isShared: zod_1.z.boolean(),
    state: exports.tableViewStateSchema,
    version: zod_1.z.number().int().nonnegative(),
});
//# sourceMappingURL=preferences.js.map